import type { SortingValue } from "../common"
import type { InventoryListFilterValue } from "./InventoryListFilterValue"

export type InventoryListSettings = SortingValue<InventoryListSortingKey> & InventoryListFilterValue

const inventoryListSortingKeys = [
	"modelInformation.name",
	"arrivalDate",
	"salesStatus",
	"mileage.value",
	"firstRegistrationDate",
	"modelInformation.modelYear",
	"price.value",
	"lastPriceChange",
	"inventoryNumber",
	"vin",
] as const

export type InventoryListSortingKey =
	| `modelInformation.name.${string}`
	| Exclude<(typeof inventoryListSortingKeys)[number], "modelInformation.name">

export const isInventoryListSortingKey = (val: unknown): val is InventoryListSortingKey => {
	return typeof val === "string" && inventoryListSortingKeys.some((key) => val.includes(key))
}
